"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpForm = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const views_1 = require("./views");
const lib_1 = require("../lib");
function SignUpForm({ redirectTo, allowWhileLoggedIn, successCallback, additionalActionProps, inputProps, submitProps, className, passwordRules, }) {
    var _a;
    const { t } = (0, app_1.useTranslation)();
    const [prevPath] = (0, app_1.useSessionStorage)('prevPath');
    const [signup] = (0, app_1.useMutation)('signup', { refetchQueries: ['me'] });
    const afterSubmit = (0, react_1.useRef)(false);
    const router = (0, app_1.useRouter)();
    const { user, loading } = (0, lib_1.useAuth)();
    const path = (_a = redirectTo !== null && redirectTo !== void 0 ? redirectTo : prevPath) !== null && _a !== void 0 ? _a : '/';
    const handleSubmit = (0, react_1.useCallback)(({ email, password, name }) => __awaiter(this, void 0, void 0, function* () {
        try {
            afterSubmit.current = true;
            const userId = yield signup({ email, password, name });
            if (userId) {
                yield (successCallback === null || successCallback === void 0 ? void 0 : successCallback(userId));
            }
            void router.push(path);
            return ui_1.SubmitState.KEEP_LOADING;
        }
        catch (error) {
            afterSubmit.current = false;
            return (0, utils_1.getErrorMessage)(error, t('error.unknown'));
        }
    }), [signup, router, path, successCallback, t]);
    (0, react_1.useEffect)(() => {
        if (!afterSubmit.current && user && !loading && !allowWhileLoggedIn) {
            void router.replace(path);
        }
    }, [user, router, loading, redirectTo, allowWhileLoggedIn, path]);
    return ((0, jsx_runtime_1.jsx)(views_1.SignUpFormView, { handleSubmit: handleSubmit, additionalActionProps: additionalActionProps !== null && additionalActionProps !== void 0 ? additionalActionProps : {}, inputProps: inputProps, className: className, submitProps: submitProps, passwordRules: passwordRules }));
}
exports.SignUpForm = SignUpForm;
